import { MenuItem, Typography } from "@mui/material";
import { BaseDropDownPropsType } from "../../../types/component.type";
import { BaseDropDownWrapper } from "./styled";

export const BaseDropDown: React.FC<BaseDropDownPropsType> = ({ open, handleClose, items, handleItemClick, className }) => {
    return (
        <BaseDropDownWrapper
            open={open}
            onClose={handleClose}
            className={className}
        >
            <ul>
                {items?.map((item, index) => {
                    return (
                        <MenuItem
                            key={index}
                            onClick={(e) => handleItemClick(e, item)}
                        >
                            {item.icon && item.icon}
                            <Typography
                                variant="subtitle1"
                                fontFamily={"Poppins"}
                                fontWeight={400}
                                fontSize={"16px"}
                                lineHeight={"normal"}
                                color={"var(--dark-color)"}
                                whiteSpace={"normal"}
                            >
                                {item.title}
                            </Typography>
                        </MenuItem>
                    )
                })}
            </ul>
        </BaseDropDownWrapper>
    )
}